import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";
import { authRepository } from "@/features/auth/repository";
import type { UserRow } from "@/types/domain";

const CURRENT_USER_STALE_MS = 60_000;

export function useCurrentUser(): UseQueryResult<UserRow | null> {
  return useQuery<UserRow | null>({
    queryKey: ["auth", "currentUser"],
    queryFn: () => authRepository.getCurrentUserProfile(),
    staleTime: CURRENT_USER_STALE_MS,
  });
}
